
<div class="row">
  <div class="col-2 offset-5">
    <div class="card">
      <article class="card-body">
        <h4 class="card-title text-center mb-4 mt-1">Sign in</h4>
        <hr>
        <div>
          {{message}}
        </div>
      </article>
    </div>
  </div>
</div>
